import Head from "next/head";

import config from "config";
import { AuthLayout } from "auth";
import TransformData from "modules/data-files/views/Transform-Data";

const Page = () => {
  return <TransformData />;
};

Page.getLayout = (page) => (
  <>
    <Head>
      <title>{config.SITE_NAME} | Transform Data</title>
    </Head>
    {/* We want users to still see their files. */}
    <AuthLayout stopExpiredUsers={false}>{page}</AuthLayout>
  </>
);

export default Page;
